import axios from "axios";
import { Encrypt, Decrypt } from "../../utils/crypto";

console.log("Axios Client Initialized. Env:", process.env.NODE_ENV);

// Environment variables only update on explicit server restart.
// In production (EC2), we use the Nginx reverse proxy at /api
const activeBaseUrl = (process.env.REACT_APP_API_BASE_URL === '/api' || process.env.NODE_ENV === 'production')
    ? '/api'
    : (process.env.REACT_APP_API_BASE_URL || 'https://uat.camsfinserv.com/api');

console.log("API Base URL used:", activeBaseUrl);

export const axiosClient = axios.create({
    baseURL: activeBaseUrl,
    headers: {
        "Content-Type": "text/plain",
    },
});

// Request interceptor for logging
axiosClient.interceptors.request.use(
    (config) => {
        console.groupCollapsed(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
        console.log("Headers:", config.headers);
        console.log("Request Body (Unencrypted):", JSON.stringify(config.data, null, 2));
        console.log("Full Config:", config);
        console.groupEnd();
        if (config.data) {
            // Encrypt payload
            const encryptedData = Encrypt(JSON.stringify(config.data));
            config.data = encryptedData;
            console.log("Encrypted Payload (Sent):", encryptedData);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for better debugging
axiosClient.interceptors.response.use(
    (response) => {
        console.groupCollapsed(`API Response: ${response.status} ${response.config.url}`);
        console.log("Response Body (Encrypted):", response.data);
        console.log("Headers:", response.headers);

        if (response.data) {
            // Attempt decryption
            const decrypted = Decrypt(response.data);
            if (decrypted) {
                console.log("Response Body (Decrypted):", decrypted);
                response.data = decrypted;
            } else if (typeof response.data === 'string' && response.data.length > 0) {
                console.warn("Response Body (Decrypted): Decryption resulted in empty/null. Key mismatch?");
                // keep original data if decryption failed but input was non-empty
            }
        }
        console.groupEnd();
        return response;
    },
    (error) => {
        // Log clean error for the user
        let parsedPayload = null;
        if (error.config && error.config.data) {
            try {
                parsedPayload = JSON.parse(error.config.data);
            } catch (e) {
                parsedPayload = error.config.data; // It's an encrypted string or unparseable
            }
        }
        
        const debugInfo = {
            status: error.response?.status,
            data: error.response?.data,
            url: error.config?.url,
            method: error.config?.method,
            payload: parsedPayload,
            headers: error.config?.headers
        };
        console.groupCollapsed(`API Error: ${error.response?.status || 'Network Error'} ${error.config?.url}`);
        console.error("Error Detail:", debugInfo);
        console.error("Full Error:", error);
        console.groupEnd();
        return Promise.reject(error);
    }
);
